import React from 'react'
import classNames from 'classnames'
import { Image } from '../../../components/Image'
import type { ImageProps } from '../../../components/Image'

type AvatarProps = ImageProps & {
  size?: number
}

export const Avatar = ({
  className,
  size = 56,
  width,
  height,
  alt = '',
  ...rest
}: AvatarProps) => (
  <Image
    className={classNames('testimonial-card__avatar', className)}
    width={width ?? size}
    height={height ?? size}
    alt={alt}
    loading="lazy"
    {...rest}
  />
)
